<template>
  <div class="v-footer"></div>
</template>

<script>
export default {
  name: 'gsodi-footer'
}
</script>

<style lang="scss">
@import '~@/components/sass/shared/colors';
@import '~@/components/sass/components/btns';
@import '~@/components/sass/shared/fonts';

.l-footer{
  background: $blue;
  color: $white;
  font-weight: 100;

  A{
    color: $white;
    text-decoration: none;

    &:hover{ color: $gray; }
  }
}

.l-footer__main{
  font-size: 0.86em;
  font-weight: 300;
  margin: 0 auto;
  padding: 25px;
  min-width: 960px;
  max-width: 1100px;
  width: 100%;
}

.l-footer__below{
  background: $gray-darkest;
  color: $white;
  font-size: 11px;
  padding: 20px;
  text-align: center;

  * {
    margin: 0;
  }
}

.l-blocks{
  display: flex; -js-display: flex;
  justify-content: space-between;
}
.l-blocks__col{
  flex: 0 0 120px;
  width: 120px;

  @media (min-width: 1000px) {
    flex: 0 0 130px;
    width: 130px;
  }
}
.l-blocks__col--last{
  flex: 1 1 auto;
  width: 100%;
}

.l-blocks__img{
  height: auto;
  max-width: 100%;
}

.block{
  margin-bottom: 20px;
  padding-left: 3px;
  padding-right: 3px;
}
.block--mt{ margin-top: 30px }

h1.block__title {
  color: $white;
  font-weight: 600;
  font-size: 13px;
  font-family: $fontfamily-sans-serif;
  margin: 0;
  padding: 0;
}
h1.block__title:after{
  border-bottom: 1px solid #FFF;
  display: block;
  content: "";
  margin: 10px 0;
  width: 95px;
}
.l-footer .block__content{
  UL{
    list-style: none;
    margin: 0;
    padding: 0;
  }
  LI{
    margin: 0;
    padding: 0;
  }
}

.social{
  display: flex; -js-display: flex;
  justify-content: flex-end;

  .btn{
    flex: 0 0 auto;
    padding: 5px;
  }

  .btn--dark:hover .btn__icon{
    stroke: transparent;
    .cls-1{ fill:  $gray-darkest; }
  }

  SVG{
    height: 16px;
    width: auto;
  }

  .cls-1{ fill: $white }
}

.social__facebook{}
.social__twitter{}
.social__youtube{}
.social__rss{}

</style>



// WEBPACK FOOTER //
// src/components/shared/footer/layout.vue